// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";

const Presentation: React.FC = () => {
    
    const { t } = useTranslation();

    return(
        <section id="presentation" className="space-ptb position-relative">
            <div className="container-fluid w-90">
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <h2>{t('homePage.presentation.subTitle')}</h2>
                    </div>
                    <div className="col-12 col-lg-6">
                        <h3 dangerouslySetInnerHTML={{ __html: t('homePage.presentation.title') as string }} />
                    </div>
                    <div className="col-12 py-5">
                        <div className="img-wrapper">
                            <img src="/assets/images/inHome/pietrasanta.jpg" alt={t('homePage.presentation.imageAlt') as string} className="img-fluid" />
                        </div>
                    </div>
                    <div className="col-12 offset-lg-6 col-lg-6">
                        <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para') as string }} />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;